import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { HelpRouteSwitch } from '~/components/Help';
import { NoticeDetailPage, NoticePage } from '~/components/Notice';

export const SupportRouteSwitch = ({ match: { path } }: RouteComponentProps) => (
  <Switch>
    <Route path={`${path}/notice/:id`} component={NoticeDetailPage} />
    <Route path={`${path}/notice`} component={NoticePage} />
    <Route path={`${path}/help`} component={HelpRouteSwitch} />
    <Redirect from={path} to={`${path}/notice`} />
  </Switch>
);
